export class TwoFactorOrganizationDuoDeleteRequest {
  constructor(public userVerificationToken: string) {}
}
